<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 86.41"
    class="svg-icon"
  >
    <path
      d="M78.736,43.174c9.235,0,16.635-7.967,16.635-17.837S87.972,7.5,78.736,7.5,62.045,15.467,62.045,25.337,69.5,43.174,78.736,43.174Zm-44.508,0c9.235,0,16.635-7.967,16.635-17.837S43.463,7.5,34.228,7.5,17.537,15.467,17.537,25.337,24.992,43.174,34.228,43.174Zm0,11.891C21.265,55.065,7.5,62.021,7.5,75.875V90.739c0,3.786,55.492,4.648,55.492,0V75.875C62.992,62.021,47.191,55.065,34.228,55.065Zm44.508,0c-1.613,0-17.869-.705-14.466,2.667s9.849,9.343,9.849,18.143V90.739c0,2.927,33.381,2.927,33.381,0V75.875C107.5,62.021,91.7,55.065,78.736,55.065Z"
      transform="translate(-7.5 -7.5)"
    />
  </svg>
</template>

<script>
export default {
  name: "IconPeopleGroup"
};
</script>
